import { FindParamsDefault } from './find-params-default';

export interface FindParamsSurvey extends FindParamsDefault {
  trigger?: string;
}
